import { clone } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component({
    components: {
       rangeSlider: require('~/components/form/range/').default,
       selectableList: require('~/components/form/selectable-list/').default,
       selectItem: require('./filter-select-item/').default,
       rangeItem: require('./filter-range-item/').default,
       boolItem: require('./filter-bool-item/').default,
    },
})
export default class CatalogFilterComponent extends Vue {

    sortTypes = [{
        value: 'default',
        name: 'Сначала популярные',
    }, {
        value: 'new',
        name: 'Сначала новинки',
    }, {
        value: 'cheap',
        name: 'Сначала дешевле',
    }, {
        value: 'expensive',
        name: 'Сначала дороже',
    }];

    @prop()
    private value: CatalogFilterField[];

    @prop()
    private orderBy: string;

    showSecondaryFilters = false;

    selectedFilter = null;

    private primaryFilterCodes = new Set(["price", "express_delivery"]);

    get primaryFilters() {

        let resultFilters: CatalogFilterField[] = [];

        if (this.availableFilters.length <= 4) {
            resultFilters = this.availableFilters;
        } else {
            resultFilters = this.availableFilters.filter((el) => this.primaryFilterCodes.has(el.code));

            // допихнем до 3 фильтров, если есть что допихивать
            if (resultFilters.length < 4 && resultFilters.length !== this.availableFilters.length) {
                resultFilters.push(
                    ...this.availableFilters
                        .filter((el) => !this.primaryFilterCodes.has(el.code)).slice(0, 4 - resultFilters.length)
                );
            }
        }

        // resultFilters.sort((a, b) => {
        //     if (a.code === 'price') {
        //         return -9999;
        //     } else if (b.code === 'price') {
        //         return 9999;
        //     }
        //     if (a.code === 'express_delivery') {
        //         return -9998;
        //     } else if (b.code === 'express_delivery') {
        //         return 9998;
        //     }

        //     return 0;
        // });

        if (resultFilters.length > 4) {
            resultFilters.splice(4);
        }

        return resultFilters;
    }

    resetFilter() {
        this.availableFilters.forEach((el) => {
            if (el.type === 'range') {
                el.values = clone(el.bounds);
            } else if (el.type === 'bool' || el.type === 'compound') {
                el.values = false;
            } else {
                el.values = [];
            }
        });
    }

    public setSort(value: string)
    {
        this.$emit('orderBy', value);
        // this.orderBy = value;
        this.selectedFilter = null;
    }

    get secondaryFilters() {
        const usedCodes = new Set(this.primaryFilters.map((el) => el.code));
        return this.availableFilters.filter((el) => !usedCodes.has(el.code));
    }

    get availableFilters() {
        return this.value.filter((el) => el.bounds || el.set || el.type === 'bool' || el.type === 'compound');
    }

    get selectedSort() {
        return this.sortTypes.find((el) => el.value === this.orderBy).name;
    }

    get availableSortOptions() {
        return this.sortTypes.filter((el) => el.value !== this.orderBy);
    }

    get triggerLabel() {
        return this.showSecondaryFilters ? 'Свернуть' : 'Развернуть';
    }
}
